<template>
  <div class="maindiv">
    <span>
      <v-menu offset-y max-height="300" z-index="333">
        <template v-slot:activator="{ on }">
          <v-btn
            id="btnClick"
            color="#234964"
            class="mt-0 mr-0"
            small
            dark
            style="
              border-top-left-radius: 4px;
              border-bottom-left-radius: 4px;
              border-top-right-radius: 0px;
              border-bottom-right-radius: 0px;
              height: 31px;
            "
            v-on="on"
            >{{ assetType }}
            <v-icon> arrow_drop_down </v-icon>
          </v-btn>
        </template>
        <v-list id="global-search-options" dense>
          <v-list-tile
            v-for="(item, index) in assetsTypes"
            :key="index"
            @click="getSelectedAsset(item)"
          >
            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </span>
    <span>
      <v-text-field
        v-model="assetName"
        placeholder=" Search for Asset(s) by name"
        clearable
        style="width: 300px"
        background-color="white"
        @keydown="nameKeydown($event)"
        @keydown.enter="performSearch"
      />
    </span>
    <span>
      <v-btn
        id="btnClick"
        color="#234964"
        class="mt-0 ml-0"
        small
        dark
        style="
          border-top-left-radius: 0px;
          border-bottom-left-radius: 0px;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
          height: 31px;
        "
        @click="performSearch"
        ><v-icon>search</v-icon>
      </v-btn>
    </span>
  </div>
</template>

<script>
import { getAssetTypesExcludingItems } from '../static/AssetTypes.js';
export default {
  name: 'GlobalSearchControl',
  data() {
    return {
      assetsTypes: getAssetTypesExcludingItems([
        'Teams',
        'OneDrive',
        'SharePoint',
        'Confluence',
      ]),
      assetType: 'All',
      assetName: '',
    };
  },
  watch: {
    assetName(val) {
      if (!val) return;
      this.assetName = val.replace('%', '');
    },
  },
  async created() {
    //Split using '/' and store each value in an array.
    const routeParams = window.location.hash.split('/');
    //Checks for the page name
    if (routeParams[1] == 'Global-Search') {
      //Assign's the first value if it's true or else the next one
      this.assetType = routeParams[2] || this.assetType;
      this.assetName = routeParams[3] || this.assetName;
    }
    if (this.$route.params.assettype != undefined) {
      this.assetType = this.$route.params.assettype;
    }
    if (this.$route.params.assetname != undefined) {
      this.assetName = this.$route.params.assetname;
    }
  },
  mounted() {
    var sortedAssetTypes = this.assetsTypes;
    sortedAssetTypes.push({
      name: 'Identities',
      entityId: 0,
      detailsPageLink: '',
      reviewSteps: '',
    });
    sortedAssetTypes = sortedAssetTypes.sort((a, b) =>
      a.name > b.name ? 1 : -1
    );
    sortedAssetTypes.unshift({
      name: 'All',
      entityId: 0,
      detailsPageLink: '',
      reviewSteps: '',
    });
    this.assetsTypes = sortedAssetTypes;
  },
  methods: {
    getSelectedAsset(item) {
      this.assetType = item.name;
      this.$emit('assetselected', item.name);
    },
    nameKeydown(e) {
      if (e.key.includes('%')) {
        e.preventDefault();
      }
    },
    performSearch() {
      if (this.assetName != undefined) {
        if (this.assetName.length >= 1) {
          window.location =
            this.SbBaseUrl +
            '/Home#/Global-Search/' +
            this.assetType +
            '/' +
            encodeURIComponent(this.assetName);
        }
      }
    },
  },
};
</script>
<style scoped>
.maindiv {
  display: flex;
  height: 100%;
  padding-top: 9px;
}
.v-text-field {
  padding-top: 0px;
}
.v-btn {
  min-width: 0px;
}
</style>
